"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderValueWithIcon = exports.renderPlaceholderWithIcon = void 0;

var _grommet = require("grommet");

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// This style recreates the placeholder colour which is lost when the placeholder element is
// customised. Note: Could also apply to the entire select with a `::placeholder` CSS block
var PlaceholderNodeStyling = _styledComponents.default.div.withConfig({
  displayName: "PlaceholderNodeStyling",
  componentId: "sc-1jmfj3z-0"
})(["color:", ";padding-bottom:0.4em;svg{font-size:1.5em;position:relative;top:0.2em;left:-0.2em;}"], (0, _helpers.color)('dark-3'));

var ValueBoxStyling = (0, _styledComponents.default)(_grommet.Box).withConfig({
  displayName: "ValueBoxStyling",
  componentId: "sc-1jmfj3z-1"
})(["border-radius:5px;padding-left:0.6em;padding-bottom:0.6em;"]);

var ValueNodeStyling = _styledComponents.default.div.withConfig({
  displayName: "ValueNodeStyling",
  componentId: "sc-1jmfj3z-2"
})(["svg{font-size:1.5em;position:relative;top:0.3em;left:-0.2em;}"]);

var renderPlaceholderWithIcon = function renderPlaceholderWithIcon(i) {
  return function (placeholder) {
    return React.createElement(PlaceholderNodeStyling, null, i, "\xA0", placeholder);
  };
};

exports.renderPlaceholderWithIcon = renderPlaceholderWithIcon;

var renderValueWithIcon = function renderValueWithIcon(i) {
  return function (value) {
    if (!value) return null;
    return React.createElement(ValueBoxStyling, null, React.createElement(ValueNodeStyling, null, i, "\xA0", value ? value.label : null));
  };
};

exports.renderValueWithIcon = renderValueWithIcon;